import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmConversationEntryDropzone.';
  public static readonly attachments = `${Id.prefix}attachments`;
  public static readonly couldNotUploadFile = `${Id.prefix}couldNotUploadFile`;
  public static readonly maxUploadCount = `${Id.prefix}maxUploadCount`;
  public static readonly chooseFiles = `${Id.prefix}chooseFiles`; // New key
  public static readonly duplicateFile = `${Id.prefix}duplicateFile`; // New key
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDealerFranchiseeConversationWmConversationEntryDropzone {
  private constructor() {}

  public static attachments(): string {
    return interpolate(Id.attachments);
  }

  public static couldNotUploadFile(): string {
    return interpolate(Id.couldNotUploadFile);
  }

  public static maxUploadCount(params: { maxFiles: number }): string {
    return interpolate(Id.maxUploadCount, params);
  }

  public static chooseFiles(): string {
    // New method
    return interpolate(Id.chooseFiles);
  }

  public static duplicateFile(): string {
    // New method
    return interpolate(Id.duplicateFile);
  }
}

export class DealerFranchiseeConversationWmConversationEntryDropzoneModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.attachments, 'Attachments', 'Caption for attachments section');
    register.add(Id.couldNotUploadFile, 'Could not upload file', 'Error message for failed upload');
    register.add(
      Id.maxUploadCount,
      'Max upload count {{maxFiles}} has been reached. Please remove a file before adding a new file.',
      'Error message when max upload count is reached'
    );
    register.add(Id.chooseFiles, 'Choose Files', 'Button: choose files'); // New registration
    register.add(Id.duplicateFile, 'This file has already been added.', 'Error: duplicate file'); // New registration
  }
}
